module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap6"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E LED ME THROUGH")]), _vm._v(" the dining room so we didn’t have to see the body of his wife in the living room.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("In the kitchen, he pointed to the breakfast nook and then he opened a cupboard door and pulled down a fresh bottle of Canadian Club. He slit the seal with his thumbnail. He grabbed two glasses, opened the refrigerator and the freezer compartment and got out a small bowl of ice, and then carried everything over to the breakfast nook where I was sitting. I’d put my .45 away. It had started to feel awfully melodramatic.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("As he poured and noisily dumped in some ice cubes, I looked out the window at a squirrel wrestling with an acorn it had found on the sunny snow. The border collie was back, too, sniffing my tires.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Sweetest dog I’ve ever owned,” Kenny Whitney said. He smiled sadly. “Wish I had her personality.” His voice startled me. I associated Kenny with the quick, derisive jab, making you feel bad for being unpopular or ugly or fat or sissy, at least in his eyes. And for short, barked threats. He was a master at short, barked threats. But this was a slow and considered voice, and it was an adult voice. That’s what startled me most. He looked a lot older than he should have, but he’d turned into an adult in the process.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Why the hell’d you shoot at me?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He shook his head, “Sorry. I was just crazy is all I can say. I wasn’t really trying to hit you, though.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You came close enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I should never have called her. Gotten her involved.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He leaned his head against the back of the nook. The kitchen sparkled. The appliances were brand-new and sat there basking in their own suburban glory. Then he sat up straight and wrapped a massive fullback’s hand around his glass. He drained the whole drink in a single swallow and then filled up again with the bottle he’d just opened. “You see her in there?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You call Sykes yet?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I wanted to make sure you were still alive.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Oh. I’m alive. Unfortunately.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You kill her, Kenny?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He looked up at me. “Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I let out a long sigh. “When?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Early last night. We were both pretty drunk.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“What happened?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“She wanted a divorce. I didn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“So you shot her?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He stared at me for a long time. “Yeah.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Don’t tell me anything more.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Because you need a lawyer.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I don’t suppose you’d want that honor?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I smiled at him. “Kenny, I don’t like you. I’ve never liked you. Believe me, you don’t want me for a lawyer.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I guess I was kind of a jerk back in school, wasn’t I?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You remember my black eye?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He shrugged. “Not really. I mean, I gave a lot of guys black eyes.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Well, you gave me mine right in front of Pamela Forrest.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He looked at me and grinned. “Oh, yeah, now I remember. Not your black eye. But Pamela. Man, you really made a fool of yourself over her.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I guess I did.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("His face became dour and old again. “Well, join the club, my friend. That’s the problem Susan and I were having. And that’s one of the reasons I killed her. She was running around on me.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Running around on you? God, look how you ran around on her.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He was pouring himself his third drink. His third drink since we’d sat down, anyway. He’d had many more during the night. “You need to keep up on the town gossip, McCain. I quit running around on her over two years ago. I even went on the wagon. She’d threatened to leave me and then I realized how much I loved her. Then she fell in love with somebody else.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Don’t tell me anything more. Save it for your lawyer.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“All I was going to say was that when she asked me for a divorce last night, I couldn’t handle it. I took down a bottle of whiskey—I’d gotten used to having it around, you know, for when we had company and stuff—and then I really started knocking down the drinks. After two years of being dry, they really hit me hard.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“So then you killed her?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He shrugged again. “Then I killed her.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("The funny thing was, I didn’t believe him. “Why’re you telling me this?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“That I killed her? Because it’s the truth. We may as well get it over with. With Sykes and all. Man, will that hillbilly be gloating. He’ll actually have a member of Judge Whitney’s family in his jail. He’ll probably play Webb Pierce records all day long.” Webb Pierce was the country-western favorite of the moment. A small Iowa town like this, people liked to show their sophistication by shunning country music. Badge of honor.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I still want to know why you’re telling me this.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I told you. Because I just want to get it over with. It’s pretty obvious that I killed her, isn’t it?” Then he drained off his drink.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I stood up. “I’m going to walk over to the phone and call Sykes.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Fine. That’s what I want you to do.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“I’m also going to call Bob Tompkins for you. He’s the best criminal attorney in this part of the state. Your aunt has a lot of respect for him.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("He looked at me abruptly. “I don’t want to have to see her again.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I wasn’t sure who he meant. “Who?”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“You know. Susan.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Okay.” Then, “It’s freezing in here.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("“Yeah, after I shot her, I guess I went a little nuts. I smashed out some windows and stuff.”")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I still didn’t believe he’d killed her and I still didn’t know why. I went to the phone and called Cliff Sykes, Jr., and listened to him try to hide his glee. Then I called Judge Whitney and repeated what I’d told Sykes. I also told her I’d like to invite Bob Tompkins in. She said she thought that was a good idea.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I had just hung up when the shot sounded. I glanced at the empty breakfast nook behind me. I had a feeling he’d been better at it this time. A kind of sorrow came over me, one I hadn’t counted on driving out here. I’d always hated him and with good reason. But he’d been sad this morning, human-animal sad, a creature frenzied and forlorn and crazed, and he wouldn’t let me hate him anymore, the son of a bitch, no matter how much I might have wanted to.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I went upstairs and found him on the bed. He looked even older now, a lot older.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-571b5140","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/11chap6.vue
// module id = 96
// module chunks = 0